var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconsWhiteTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons / White / Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.43959 7.16344 0.5 16 0.5C24.8366 0.5 32 7.43959 32 16C32 24.5604 24.8366 31.5 16 31.5C7.16344 31.5 0 24.5604 0 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5208 13.0986L15.5544 13.635L14.9948 13.5693C12.9579 13.3176 11.1784 12.4638 9.66756 11.0299L8.92891 10.3185L8.73865 10.8438C8.33575 12.015 8.59316 13.2519 9.43253 14.0837C9.8802 14.5435 9.77948 14.6091 9.00725 14.3355C8.73865 14.2479 8.50363 14.1823 8.48124 14.2151C8.4029 14.2917 8.6715 15.2878 8.88414 15.6818C9.17513 16.2291 9.76828 16.7654 10.4174 17.0828L10.9658 17.3346L10.3167 17.3455C9.68994 17.3455 9.66756 17.3565 9.73471 17.5863C9.95854 18.2978 10.8427 19.0531 11.8276 19.3814L12.5214 19.6113L11.9171 19.9615C11.0218 20.465 9.96973 20.7496 8.91772 20.7715C8.41409 20.7825 8 20.8262 8 20.8591C8 20.9685 9.36538 21.5815 10.16 21.8223C12.5438 22.5338 15.3753 22.2273 17.5017 21.0123C19.0126 20.1476 20.5235 18.4292 21.2286 16.7654C21.6091 15.8788 21.9896 14.2589 21.9896 13.4817C21.9896 12.9782 22.0232 12.9126 22.6499 12.3106C23.0192 11.9603 23.3662 11.5772 23.4333 11.4677C23.5452 11.2598 23.534 11.2598 22.9633 11.4459C22.012 11.7742 21.8777 11.7304 22.3477 11.2379C22.6947 10.8876 23.1088 10.2528 23.1088 10.0667C23.1088 10.0339 22.9409 10.0886 22.7506 10.1871C22.5492 10.2966 22.1015 10.4608 21.7658 10.5593L21.1614 10.7453L20.613 10.3841C20.3108 10.1871 19.8856 9.9682 19.6617 9.90252C19.0909 9.74929 18.218 9.77118 17.7032 9.94631C16.3042 10.4389 15.4201 11.7085 15.5208 13.0986Z",
    fill: "#759CEA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconsWhiteTwitter);
export default __webpack_public_path__ + "static/media/social-icons-white-twitter.7cddad0d203c9096aa3ae9e75f527321.svg";
export { ForwardRef as ReactComponent };